export enum Metrics {
  HeartRate = 'heart_rate',
  Calories = 'calories',
  Cadence = 'cadence',
  SubsegmentId = 'subsegment_id',
}
